import { DATE_FORMAT } from '@dev-spendesk/grapes';

import { useTranslation } from 'common/hooks/useTranslation';

type MonthStats = {
  month: number;
  year: number;
};

type Props = {
  stats: MonthStats;
};

export const PayableTableGroup = ({ stats }: Props) => {
  const { localeFormat } = useTranslation('global');

  return (
    <div className="flex justify-between py-8 uppercase text-content-secondary-bg-secondary body-s">
      <span>
        {localeFormat(new Date(stats.year, stats.month), DATE_FORMAT.CUSTOM, {
          month: 'short',
          year: 'numeric',
        })}
      </span>
    </div>
  );
};
